import QRCode from 'qrcode-svg';

const qrSvg = (content, frontColor, backColor, size, elementId) => {
    let qrSvg = new QRCode({
        content,
        width: size,
        height: size,
        color: `#${frontColor.hex}`,
        background: `#${backColor.hex}`,
        padding: 0,
        join: true
    }).svg();

    document.querySelector(`[id="${elementId}"] div.editorQrCodeElement`).innerHTML = qrSvg;
}

export { qrSvg };